<script setup lang="ts">
import AppMainMenu from '@/components/core/layout/AppMainMenu.vue';
import AppSession from '@/components/core/layout/AppSession.vue';
import UiLogo from '@/components/core/UiLogo.vue';
import UiTitle from '@/components/core/UiTitle.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <header class="ui-bg-primary max-desktop:landscape:flex-col relative z-30 flex min-h-24 items-center justify-between gap-12 p-2 shadow-lg">
    <div class="max-desktop:landscape:flex-col flex items-center gap-6">
      <AppMainMenu />
      <UiLogo />
      <UiTitle class="max-desktop:tablet:hidden">{{ t('core.appName') }}</UiTitle>
    </div>
    <AppSession />
  </header>
</template>
